import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Section from '@/components/Section/Section';
import banner from '@/public/payyment_processing/paymentProcessingBanner.webp';
import { devices } from '@/styles/breakpoints';

export const PaymentProcessingBaner = () => {
  return (
    <Wrapper>
      <Section>
        <Image src={banner} alt="banner" />
      </Section>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  & img {
    height: 80px;
    width: 100%;
  }
  @media only screen and ${devices.desktop} {
    & img {
      height: 120px;
      display: block;
      margin: 0 auto;
    }
  }
`;
